import config from '../config';

// A function, not a constant: in Solvie the settings only exist once Cato's pane has mounted
export const getDatadogTags = (): Record<'team' | 'costcenter' | 'appgroup' | 'retention', string> => ({
  team: 'customer-service',
  costcenter: 'customer-service',
  appgroup: 'customer-service-cc',
  retention: config.datadogEnv?.toLowerCase() === 'production' ? '30' : '7'
});
